import { Button, InfiniteScroll, Progress } from "nq-component";
import BaseListPage from "../../../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import CardView from "../../../../components/common/CardView";
import Table from "../../../../components/Table";
import Search from "../../../../components/Search";
import withRouter from "../../../../withRouter";
import ExternalTrainingForm from "./externalTraining/ExternalTrainingForm";
import ExternalTrainingPagePresenter from "./ExternalTrainingPagePresenter";
import DateRangePicker from "../../../../components/common/DateRangePicker";

class ExternalTrainingPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new ExternalTrainingPagePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      progress: false,
      objects: [],
      object: {},
      action: "",
      trainings: [],
      filterTrainings: "",
      isTrainingFormOpen: false,
      newObj: [],
      formMode: "Add",
      count: 0,
      limit: 10,
      current: 1,
    };
  }
  getCurrent() {
    return this.getCurrentUser();
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
  }

  getCollectionName() {
    return "external_training";
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }
  handleAddTraining() {
    this.setState({
      isTrainingFormOpen: true,
      object: {},
      action: "",
      formMode: "Add",
    });
  }

  async handleEdit(objectID) {
    const objects = await findObjectUseCase().execute("external_training");
    const object = objects.find((item) => item.id === objectID);
    this.setState({
      object,
      action: "edit",
      isTrainingFormOpen: true,
      formMode: "Edit",
    });
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, formMode, count, current, limit } = this.state;
    if (!schema) return <Progress />;
    console.log("OBJE: ", objects);
    return (
      <>
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!this.state.progress && count > newObj.length}
          >
            <div className="">
              <CardView style={{ borderRadius: 0 }}>
                <div className="row d-flex align-items-center">
                  <div className="col-md-6 mt-1">
                    <DateRangePicker
                      fields={["datefrom", "dateto", "employee.id"]}
                      onFilter={(filterObj) => {
                        this.searchSubmit(filterObj);
                      }}
                    />
                  </div>
                  <div className="col-md-6 mt-1">
                    <Search
                      schemas={this.getSchemas()}
                      onSubmit={this.searchSubmit.bind(this)}
                      fields={schema.fields}
                    />
                  </div>
                </div>
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center">
                    <h4 className="text-primary">{schema.label}</h4>
                    <div style={{ marginLeft: "auto" }}>
                      <Button onClick={this.handleAddTraining.bind(this)}>
                        <i className="bi bi-plus-lg" /> Add Training
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                progress={loading}
                objectId={this.handleEdit.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-pencil-square"> Edit</i>,
                    actionType: "delete",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "Created At", "Updated At", "datefrom", "dateto"]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
        {this.state.isTrainingFormOpen && (
          <ExternalTrainingForm
            closeTrainingForm={() =>
              this.setState({ isTrainingFormOpen: false })
            }
            refetchData={this.refetchData.bind(this)}
            object={this.state.object}
            action={this.state.action}
            formMode={formMode}
          />
        )}
      </>
    );
  }
}

export default withRouter(ExternalTrainingPage);
